var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    [
      _c("base-snackbar", {
        attrs: { errors: _vm.cxForecastPostErrors },
        on: {
          "update:errors": function($event) {
            _vm.cxForecastPostErrors = $event
          }
        }
      }),
      _c("base-snackbar", {
        attrs: { errors: _vm.stockCategoryGetErrors },
        on: {
          "update:errors": function($event) {
            _vm.stockCategoryGetErrors = $event
          }
        }
      }),
      _c("base-snackbar", {
        attrs: { errors: _vm.fdPrgmCategoryGetErrors },
        on: {
          "update:errors": function($event) {
            _vm.fdPrgmCategoryGetErrors = $event
          }
        }
      }),
      _c(
        "v-overlay",
        {
          attrs: { absolute: "", color: "primary", value: _vm.populatingInputs }
        },
        [
          _c("v-progress-circular", {
            attrs: { color: "white", indeterminate: "", size: "60" }
          })
        ],
        1
      ),
      _c(
        "v-toolbar",
        {
          attrs: {
            color: _vm.editMode ? "yellow darken-3" : "primary",
            dark: "",
            dense: ""
          }
        },
        [
          _c("span", [
            _vm._v(
              _vm._s(_vm.editMode ? "Edit" : "Create") +
                " Forecast - " +
                _vm._s(_vm.customerData.company)
            )
          ]),
          _c("v-spacer"),
          _c(
            "v-btn",
            {
              attrs: { text: "", small: "" },
              on: {
                click: function($event) {
                  return _vm.populateInputs(_vm.defaultFieldValues)
                }
              }
            },
            [_c("v-icon", [_vm._v("mdi-pencil")])],
            1
          )
        ],
        1
      ),
      _c(
        "v-row",
        [
          _c(
            "v-col",
            { attrs: { lg: "3", cols: "12" } },
            [
              _c(
                "v-row",
                [
                  _c(
                    "v-col",
                    { attrs: { cols: "12" } },
                    [
                      _c("v-autocomplete", {
                        attrs: {
                          label: "Stock Category",
                          items: _vm.stockCategoryList,
                          "item-value": "id",
                          "item-text": "name",
                          "return-object": "",
                          loading: _vm.stockCategoryGetting,
                          "error-messages":
                            _vm.cxForecastPostErrors.stock_category_id
                        },
                        scopedSlots: _vm._u(
                          [
                            _vm.stockCategory.sow_pig_cycle_preference
                              ? {
                                  key: "append",
                                  fn: function() {
                                    return [
                                      _c(
                                        "base-tooltip",
                                        {
                                          attrs: {
                                            color: _vm.editMode
                                              ? "yellow darken-3"
                                              : "primary",
                                            text: "",
                                            "x-small": "",
                                            dark: "",
                                            tooltip: _vm.editMode
                                              ? "Edit Sow Pig"
                                              : "Attach Sow Pig"
                                          },
                                          on: {
                                            click: _vm.openDialogAttachSowPig
                                          }
                                        },
                                        [
                                          _c("v-icon", [
                                            _vm._v("mdi-book-sync")
                                          ])
                                        ],
                                        1
                                      )
                                    ]
                                  },
                                  proxy: true
                                }
                              : null
                          ],
                          null,
                          true
                        ),
                        model: {
                          value: _vm.stockCategory,
                          callback: function($$v) {
                            _vm.stockCategory = $$v
                          },
                          expression: "stockCategory"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { attrs: { cols: "12" } },
                    [
                      !_vm.stockCategory.sow_pig_cycle_preference
                        ? _c("v-text-field", {
                            attrs: {
                              label: "Quantity",
                              type: "number",
                              "error-messages":
                                _vm.cxForecastPostErrors.quantity
                            },
                            model: {
                              value: _vm.quantity,
                              callback: function($$v) {
                                _vm.quantity = $$v
                              },
                              expression: "quantity"
                            }
                          })
                        : _c("v-text-field", {
                            attrs: {
                              label: "Quantity",
                              type: "number",
                              disabled: "",
                              value: 1,
                              "error-messages":
                                _vm.cxForecastPostErrors.quantity
                            }
                          })
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { attrs: { cols: "12" } },
                    [
                      _c("v-text-field", {
                        attrs: {
                          label: "Days",
                          type: "number",
                          "error-messages": _vm.cxForecastPostErrors.days
                        },
                        model: {
                          value: _vm.days,
                          callback: function($$v) {
                            _vm.days = $$v
                          },
                          expression: "days"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { attrs: { cols: "12" } },
                    [
                      _c("v-text-field", {
                        attrs: {
                          label: "Date Confirmed",
                          type: "date",
                          "error-messages":
                            _vm.cxForecastPostErrors.date_confirmed
                        },
                        model: {
                          value: _vm.dateConfirmed,
                          callback: function($$v) {
                            _vm.dateConfirmed = $$v
                          },
                          expression: "dateConfirmed"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { attrs: { cols: "12" } },
                    [
                      _c("v-text-field", {
                        attrs: {
                          label: "Date Start",
                          type: "date",
                          "error-messages": _vm.cxForecastPostErrors.date_start
                        },
                        model: {
                          value: _vm.dateStart,
                          callback: function($$v) {
                            _vm.dateStart = $$v
                          },
                          expression: "dateStart"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { attrs: { cols: "12" } },
                    [
                      _c("v-checkbox", {
                        attrs: {
                          label: "Closed",
                          "error-messages": _vm.cxForecastPostErrors.closed
                        },
                        model: {
                          value: _vm.closed,
                          callback: function($$v) {
                            _vm.closed = $$v
                          },
                          expression: "closed"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { attrs: { cols: "6" } },
                    [
                      _c(
                        "v-btn",
                        {
                          attrs: {
                            block: "",
                            color: "primary",
                            loading: _vm.cxForecastPosting
                          },
                          on: { click: _vm.sendRequestToCustomerForecast }
                        },
                        [_c("span", [_vm._v("Save")])]
                      )
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { attrs: { cols: "6" } },
                    [
                      _c(
                        "v-btn",
                        {
                          attrs: { block: "", color: "error" },
                          on: {
                            click: function($event) {
                              return _vm.$router.push({
                                name: "customers.forecasts.table",
                                params: { customerId: _vm.customerData.id }
                              })
                            }
                          }
                        },
                        [_c("span", [_vm._v("Cancel")])]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "v-col",
            { attrs: { lg: "9", cols: "12" } },
            [
              _c(
                "v-card",
                {
                  staticClass: "mt-2",
                  attrs: { elevation: "0", "min-height": "50vh" }
                },
                [
                  _c(
                    "v-container",
                    [
                      _c(
                        "v-overlay",
                        {
                          attrs: {
                            color: "purple darken-3",
                            value:
                              _vm.fdPrgmCategoryGetting &&
                              !_vm.populatingInputs,
                            absolute: ""
                          }
                        },
                        [
                          _c("v-progress-circular", {
                            attrs: { indeterminate: "", size: "64" }
                          })
                        ],
                        1
                      ),
                      _vm._l(_vm.forecasts, function(item, index) {
                        return _c(
                          "div",
                          { key: index },
                          [
                            _c(
                              "v-row",
                              [
                                _c(
                                  "v-col",
                                  { attrs: { cols: "3" } },
                                  [
                                    _c("v-text-field", {
                                      attrs: {
                                        label: "Type",
                                        value: item.description,
                                        readonly: "",
                                        "error-messages":
                                          _vm.cxForecastPostErrors[
                                            `types.${index}.type`
                                          ]
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _c(
                                  "v-col",
                                  { attrs: { cols: "3" } },
                                  [
                                    _c("v-autocomplete", {
                                      attrs: {
                                        label: "Stock Code",
                                        items: item.feedingPrograms,
                                        "item-value": "stock_id",
                                        "error-messages":
                                          _vm.cxForecastPostErrors[
                                            `types.${index}.stock_id`
                                          ]
                                      },
                                      on: {
                                        change: function($event) {
                                          return _vm.feedingProgramChangeEvent(
                                            item,
                                            index
                                          )
                                        }
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "selection",
                                            fn: function({ item }) {
                                              return [
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "stock-description blue-grey--text mx-1"
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(item.stock_id)
                                                    )
                                                  ]
                                                )
                                              ]
                                            }
                                          },
                                          {
                                            key: "item",
                                            fn: function({ item }) {
                                              return [
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass: "primary--text"
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(item.stock_id)
                                                    )
                                                  ]
                                                ),
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "blue-grey--text mx-1 text-caption"
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        item.stock.description
                                                      )
                                                    )
                                                  ]
                                                )
                                              ]
                                            }
                                          }
                                        ],
                                        null,
                                        true
                                      ),
                                      model: {
                                        value: item.stockId,
                                        callback: function($$v) {
                                          _vm.$set(item, "stockId", $$v)
                                        },
                                        expression: "item.stockId"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _c(
                                  "v-col",
                                  { attrs: { cols: "3" } },
                                  [
                                    _c("v-text-field", {
                                      attrs: {
                                        label: "Date Start",
                                        type: "date",
                                        readonly: "",
                                        "error-messages":
                                          _vm.cxForecastPostErrors[
                                            `types.${index}.date_start`
                                          ]
                                      },
                                      model: {
                                        value: item.dateStart,
                                        callback: function($$v) {
                                          _vm.$set(item, "dateStart", $$v)
                                        },
                                        expression: "item.dateStart"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _c(
                                  "v-col",
                                  { attrs: { cols: "3" } },
                                  [
                                    _c("v-text-field", {
                                      attrs: {
                                        label: "Date End",
                                        type: "date",
                                        readonly: ""
                                      },
                                      model: {
                                        value: item.dateEnd,
                                        callback: function($$v) {
                                          _vm.$set(item, "dateEnd", $$v)
                                        },
                                        expression: "item.dateEnd"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _c("v-divider")
                          ],
                          1
                        )
                      })
                    ],
                    2
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "v-dialog",
        {
          attrs: { "max-width": "800", eager: "" },
          model: {
            value: _vm.sowPigDialog,
            callback: function($$v) {
              _vm.sowPigDialog = $$v
            },
            expression: "sowPigDialog"
          }
        },
        [
          _c(
            "v-card",
            [
              _c(
                "v-toolbar",
                {
                  attrs: {
                    color: _vm.editMode ? "yellow darken-3" : "primary",
                    dense: "",
                    elevation: "0",
                    dark: ""
                  }
                },
                [
                  _c("span", [
                    _vm._v(
                      _vm._s(_vm.editMode ? "Edit Sow Pig" : "Attach Sow Pig")
                    )
                  ])
                ]
              ),
              _c(
                "v-container",
                [
                  _c("sow-pig-form", {
                    attrs: { errors: _vm.sowPigErrors },
                    model: {
                      value: _vm.sowPigData,
                      callback: function($$v) {
                        _vm.sowPigData = $$v
                      },
                      expression: "sowPigData"
                    }
                  }),
                  _vm.editMode
                    ? _c(
                        "div",
                        [
                          _c(
                            "v-btn",
                            {
                              attrs: {
                                color: "yellow darken-3",
                                dark: "",
                                dense: "",
                                small: "",
                                loading: _vm.sowPigPutting
                              },
                              on: { click: _vm.sendRequestSowPigAndForecast }
                            },
                            [_c("span", [_vm._v("Save")])]
                          ),
                          _c(
                            "v-btn",
                            {
                              staticClass: "ml-2",
                              attrs: {
                                color: "success",
                                dark: "",
                                dense: "",
                                small: ""
                              },
                              on: { click: _vm.revertSowPig }
                            },
                            [_c("span", [_vm._v("Restore")])]
                          )
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }